import { ValueContainer } from './ValueContainer';

export default ValueContainer;
